declare let THREE: any;

export class LocalSpaceOffsetCalculator {

  private halfSizes = new THREE.Vector3();
  private offset = new THREE.Vector3();

  calculate(localScaleDirection, length: number, height: number) {
    this.offset.copy(localScaleDirection);
    this.halfSizes.set(length / 2, height / 2, 0);
    this.offset.multiply(this.halfSizes);
    return this.offset;
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/LocalSpaceOffsetCalculator.ts